import { render, staticRenderFns } from "./Toastification.vue?vue&type=template&id=2bbdd7b6"
import script from "./Toastification.vue?vue&type=script&lang=js"
export * from "./Toastification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports